import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import chunk from 'lodash/chunk';

import { Title, Item } from '../index';
import { toVw, toVwMobile, toVwTablet } from '../../../../../utils/styles';
import mq from '@/utils/media-queries';

const Cols = styled.div`
  display: flex;
`;

const Col = styled.div`
  padding-right: ${toVw(50)};
  box-sizing: border-box;

  &:first-child {
    width: ${toVw(540)};
  }

  ${mq.tablet(css`
    &:first-child {
      width: ${toVwTablet(396)};
      padding-right: ${toVwTablet(80)};
    }
  `)};

  ${mq.mobile(css`
    &:first-child {
      width: ${toVwMobile(286)};
      padding-right: ${toVwMobile(30)};
    }
  `)};
`;

const DutiesEmployer = ({ className, duties }) => {
  const columns = chunk(duties, Math.ceil(duties.length / 2));

  return (
    <div className={className}>
      <Title>We will</Title>
      <Cols>
        {columns.map((items, index) => (
          <Col key={index}>
            {items.map((item, itemIndex) => (
              <Item key={itemIndex}>{item}</Item>
            ))}
          </Col>
        ))}
      </Cols>
    </div>
  );
};

DutiesEmployer.propTypes = {
  className: PropTypes.string,
  duties: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default DutiesEmployer;



// WEBPACK FOOTER //
// ./src/scenes/Vacancy/components/Duties/components/DutiesEmployer.js